import { render, staticRenderFns } from "./RewardBox.vue?vue&type=template&id=034d359e&"
import script from "./RewardBox.vue?vue&type=script&lang=js&"
export * from "./RewardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports